// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sz-apex-chart-actions[data-v-4bbb97c3] {\n  position: absolute;\n  right: 25px;\n  top: -2px;\n}\n", ""]);
// Exports
module.exports = exports;
